import React from 'react';
import { motion } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  delay?: number;
}
export function Section({
  children,
  className,
  id,
  delay = 0
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} className={cn('py-16 md:py-24 px-6 md:px-12 max-w-6xl mx-auto w-full', className)} data-id="element-173">
      {children}
    </motion.section>;
}